import axios from "axios";
import CustomInterceptors from "@/api/Auth/GAInterceptors";

const instanceGA = axios.create({    
  baseURL: process.env.VUE_APP_GLOBALAUTH_API
});

instanceGA.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceGA.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default instanceGA;

